export default __webpack_public_path__ + "static/media/damir-bosnjak.efcaca50.jpg";